<template>
    <div>
      <div>
      <nav class="w-52 bg-white fixed left-0 top-0  min-h-screen  shadow-md">
      <div class="pt-14 pl-14 ">
         <h3>Tally<span class="text-green-500">Clinic</span></h3>
      </div>
      <h6 class="mt-8 pl-4 text-gray-400">Menu</h6>
  <ul class="flex flex-col items-center ">
    <li class="h-9 w-full ">
      <a href="#" class="bg-link-hover w-full  flex items-center p-0 pl-4 text-gray-400 relative active">
       <i class="far fa-comment-dots mr-3"></i>
         <span class="link-label">Integrate</span>
      </a>
    </li>
    <!--  -->
    <li class="h-9 w-full">
      <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full  flex items-center p-0 pl-4 text-gray-400  relative">
        <i class="fas fa-signal mr-3"></i>
       <span class="link-label">Manage</span>
      </a>
    </li>
    <!--  -->
    <li class="h-9 w-full">
      <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
       <i class="far fa-hospital mr-3"></i>
        <span class="link-label">Print</span>
      </a>
    </li>
    <!--  -->
    <li class="h-9 w-full">
      <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
       <i class="fas fa-chart-line mr-3"></i>
       <span class="link-label">Report</span>
      </a>
    </li>
    <!--  -->
    <li class="h-9 w-full">
      <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full  flex items-center p-0  pl-4 text-gray-400  relative">
      <i class="fas fa-users mr-3"></i>
   <span class="link-label">Analyse</span>
      </a>
    </li>
    <!--  -->
    <li class="h-9 w-full">
      <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
       <i class="far fa-comments mr-3"></i>
    <span class="link-label">Sync</span>
      </a>
    </li>
    <!--  -->
    <li class="h-9 w-full">
      <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
       <i class="fas fa-cogs mr-3"></i>
        <span class="link-label">Tally-on-Cloud</span>
      </a>
    </li>
    <!--  -->
    <li class="h-9 w-full">
      <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
       <i class="fas fa-cogs mr-3"></i>
        <span class="link-label">Add-Ons</span>
      </a>
    </li>
    <!--  -->
    <li class="h-9 w-full">
      <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
       <i class="fas fa-cogs mr-3"></i>
        <span class="link-label">Modules</span>
      </a>
    </li>
    <!--  -->
    <li class="h-9 w-full">
      <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
       <i class="fas fa-cogs mr-3"></i>
        <span class="link-label">Services</span>
      </a>
    </li>
    <!--  -->
    <li class="h-9 w-full">
      <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
       <i class="fas fa-cogs mr-3"></i>
        <span class="link-label">Trainings</span>
      </a>
    </li>
    <!--  -->
     <li class="h-9 w-full">
      <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
       <i class="fas fa-cogs mr-3"></i>
        <span class="link-label">Webinars</span>
      </a>
    </li>
    <!--  -->
  </ul>

          
            <h6 class="text-gray-400 mt-9 ml-4">Account</h6>
              <ul>
                <!--  -->
                <li class="h-9 w-full">
              <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
              <i class="fas fa-cogs mr-3"></i>
                <span class="link-label">Help & Support</span>
              </a>
            </li>
            <!--  -->
             <li class="h-9 w-full">
              <a href="#" class="hover:bg-link-hover transition-colors duration-500 w-full flex items-center p-0 pl-4 text-gray-400  relative">
              <i class="fas fa-cogs mr-3"></i>
                <span class="link-label">Log Out</span>
              </a>
            </li>
            <!--  -->
              </ul>

        
      </nav>
      </div>

      <!-- main page -->
      <div class="main-content">
			<h1>Dashboard</h1>
			<p>Here you can stuff!</p>
			<div class="panel-wrapper">
				<div class="panel-body d-flex flex-row">
                    <img src="imgs/tally_banner.png" alt="">
                    <div class="text-left mt-10">
					Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam fugiat culpa quia possimus molestiae id sapiente ad eveniet, aliquid, eum sint fuga eius, ratione suscipit ut minus voluptates dicta nesciunt.
                    </div>
				</div>
			</div>

       <!-- cards start from here -->
    <div class="cont">
            
        <div class="cardnen">
            <div class="mt-3 ml-3 text-gray-400 text-3xl icon">
          <i class="fas fa-spa"></i>
            </div>
        <a class="mtnpaiin ml-3 mt-3 leading-4" href="#">Baking Recipies</a>
        </div>

        <div class="cardnen">
           <div class="mt-3 ml-3 text-gray-400 text-3xl icon">
          <i class="fas fa-spa"></i>
            </div> 
        <a class="mtnpaiin ml-3 mt-3 leading-4" href="#">Baking Recipies</a>
        </div>

        <div class="cardnen">
          <div class="mt-3 ml-4 text-gray-400 text-3xl icon">
          <i class="fas fa-spa"></i>
            </div>
       <a class="mtnpaiin ml-3 mt-3 leading-4" href="#">Baking Recipies</a>
        </div>

        <div class="cardnen">
            <div class="mt-3 ml-4 text-gray-400 text-3xl icon">
          <i class="fas fa-spa"></i>
            </div>
       <a class="mtnpaiin ml-3 mt-3 leading-4" href="#">Baking Recipies</a>
        </div>

        <div class="cardnen">
             <div class="mt-3 ml-4 text-gray-400 text-3xl icon">
          <i class="fas fa-spa"></i>
            </div>
        <a class="mtnpaiin ml-3 mt-3 leading-4" href="#">Baking Recipies</a>
        </div>

        <div class="cardnen">
           <div class="mt-3 ml-4 text-gray-400 text-3xl icon">
          <i class="fas fa-spa"></i>
            </div> 
        <a class="mtnpaiin ml-3 mt-3 leading-4" href="#">Baking Recipies</a>
        </div>

        <div class="cardnen">
            <div class="mt-3 ml-4 text-gray-400 text-3xl icon">
          <i class="fas fa-spa"></i>
            </div>
        <a class="mtnpaiin ml-3 mt-3 leading-4" href="#">Baking Recipies</a>
        </div>

        <div class="cardnen">
            <div class="mt-3 ml-4 text-gray-400 text-3xl icon">
          <i class="fas fa-spa"></i>
            </div>
        <a class="mtnpaiin ml-3 mt-3 leading-4" href="#">Baking Recipies</a>
        </div>

        <div class="cardnen">
            <div class="mt-3 ml-4 text-gray-400 text-3xl icon">
          <i class="fas fa-spa"></i>
            </div>
        <a class="mtnpaiin ml-3 mt-3 leading-4" href="#">Baking Recipies</a>
        </div>
   
    </div>
       <!-- cards ends here -->
	</div>
    </div>
</template>

<script>
export default {
   mounted(){
//        const links = document.querySelectorAll("ul li a");
// const nav = document.querySelector("nav");
// const menuIcon = document.querySelector("nav svg");
// function clear(){
//   links.forEach(l=>l.classList.remove("active"))
// }
// links.forEach(l=>{
//   l.onclick = (e)=>{
//     clear()
//     e.target.classList.add("active")
//   }
// })
// menuIcon.onclick  = ()=>{
//  nav.classList.toggle("expanded")
// }
//    } 
  $('li').on('click',function(){
    var a_links = $(this).find('a');
    $('a').removeClass('active');
    a_links.addClass('active');
  })
}
}
</script>

<style scoped>
body {
  min-height: 100vh;
  background-color: #dbe3ff;
  padding: 30px;
}
html{
  font-family:Rubik !important;
}
a.active {
  color:#10b981;
  font-weight: 300;
   /* background: #abffe3; */
}
 a.active::after {
  content: "";
  height: 100%;
  position: absolute;
  left: 205px;
  top: 0;
  width: 4px;
  background-color: #10b981;
}
a:hover{
  /* background-color: #10b981; */
  color: #10b981;
  text-decoration: none;
}
nav{
  transition:all .2s;
  /* border: 2px solid rgb(233, 233, 233); */
}

nav.expanded .link-label {
  display: none;
}
nav.expanded {
  width: 66px;
}
nav.expanded ul li{
  align-items: center;
  justify-content: center;
}
nav.expanded ul li a{
  align-items: center;
  justify-content: center;
}
nav.expanded ul li a svg{
 margin: 0;
}

/* main page */

.main-content {
	background-color: #fff;
	/* width: calc(100% - 250px); */
	height: 100vh;
	margin-left: 225px;
	padding: 20px 30px;
}
.main-content .panel-wrapper {
	margin: 20px 0;
	box-shadow: 0px 1px 3px #777;
}
.main-content .panel-wrapper .panel-body {
	padding: 10px 10px;
	font-size: 80%;
}

@media only screen and (max-width: 420px){
	.main-content {
		width: 100%;
		margin-left: 0;
		z-index: -1;
		position: relative;
	}
}

@media only screen and (max-width: 768px){
	.main-content {
		width: 100%;
		margin-left: 0;
		z-index: -1;
		position: relative;
	}
}

/* cards css start from here */
.cardnen {
    width: 120px;
    height: 120px;
    background-color: #fff;
    margin: 10px;
    border-radius: 10px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    position: relative;
    cursor: pointer !important;
    z-index: 1;
    transition: all ease 0.2s;
}

.cardnen:hover {
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
    transform: translateY(-0.5rem);
    background-color:#10b981 ;

}
 .cardnen.icon i{
     color: #10b981;     
}
.cont {
    display: flex;  
}

.mtnpaiin {
    position: absolute;
    color:#b5b5b5 ; 
    text-align:left;
    font-size:medium;   
}

.cardnen:hover .mtnpaiin{
 color: #fff !important; 
}

.cardnen:hover .icon{
color: #fff !important;
}

</style>